
import { isMobile } from '~/helpers/mobile/DeviceType'
export default {
  name: 'SectionIntroV2',
  props: {
    data: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    hash: {
      required: true,
      type: String,
      default: ''
    }
  },
}
